module.exports = __webpack_public_path__ + "media/images/modules/root_on_talkport/step3-23b09f3193304b1f47efc90a98f324bb.png";